import { useAccessToken } from "../../contexts/AccessTokenContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const authRedirectUri = import.meta.env.VITE_AUTH_REDIRECT_URL || "";
const logisticsHost = import.meta.env.VITE_AUTH_REDIRECT_URL_LOGOUT || "";

const Logout = () => {
  const navigate = useNavigate();
  const { clearAccessToken } = useAccessToken();
  useEffect(() => {
    // Clear access token ผ่าน Context
    clearAccessToken();

    // Optionally clear other related user data
    localStorage.removeItem("userData");

    // Redirect to login
    navigate("/", { replace: true });
  }, [navigate, clearAccessToken]);

  return (
    <div>
      <h1>Logout Success</h1>
    </div>
  );
};

export default Logout;
